module.exports = __webpack_public_path__ + "img/user-dummy-img.d768f4f6.jpg";